import React from 'react';
import { XCircleIcon } from '@heroicons/react/20/solid'
import noop from '../../utils/noop';

interface ErrorCardProps {
  title: string;
  message: string;
  callToActionText?: string;
  onClickCallToAction?: () => void;
}

export default function ErrorCard(props: ErrorCardProps) {
  return (
    <div className="rounded-md bg-red-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">{props.title}</h3>
          <div className="mt-2 text-sm text-red-700">
            <p>{props.message}</p>
          </div>
          {props.callToActionText ? <div className="mt-4">
            <div className="-mx-2 -my-1.5 flex">
              <button
                type="button"
                onClick={props.onClickCallToAction ? props.onClickCallToAction : noop}
                className="rounded-md bg-red-50 px-2 py-1.5 text-sm font-medium text-red-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-50"
              >
                {props.callToActionText}
              </button>
            </div>
          </div> : <></>}
        </div>
      </div>
    </div>
  )
}
